import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import React from 'react'
import Theme from 'core/themes/model'
import Text from '../Text'

interface CardHeaderProps {
  children?: React.ReactNode
  className?: string
}

export default function CardHeader({ children, className }: CardHeaderProps) {
  const classes = useStyles()
  return (
    <Text variant="subtitle2" className={clsx('card-header', classes.header, className)}>
      {children}
    </Text>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  header: {
    padding: '16px 32px',
    borderBottom: `1px solid ${theme.components.card.border}`,
  },
}))
